// extracted by mini-css-extract-plugin
export var arrows = "_6l-6";
export var decrementer = "_6l-a";
export var disabled = "_6l-4";
export var error = "_6l-1";
export var hiddenText = "_6l-b";
export var incrementer = "_6l-9";
export var input = "_6l-8";
export var inputWrapper = "_6l-0";
export var leadingIcon = "_6l-c";
export var readonly = "_6l-3";
export var regular = "_6l-7";
export var small = "_6l-5";
export var warning = "_6l-2";